{
  "home": {
    "tagline": "Ponad 1 milion właścicieli psów trenuje z Hundeo",
    "subline": "Polecana przez prawdziwych trenerów psów",
    "appStorePrefix": "Pobierz w",
    "playStorePrefix": "Pobierz z",
    "qrHint": "Otwórz aplikację na telefonie",
    "qrCaption": "Zeskanuj kod aparatem",
    "socialProof": "5 000+ pięciogwiazdkowych ocen",
    "imprint": "Impressum",
    "privacy": "Prywatność",
    "language": "Język",
    "openWebsite": "Przejdź do strony",
    "openInApp": "Otwórz w aplikacji Hundeo",
    "openInAppHint": "Przeniesiemy Cię do aplikacji",
    "openInAppButton": "Otwórz",
    "promoRedirectTitle": "Otwieramy Twoją ofertę …",
    "promoRedirectButton": "Przejdź do oferty"
  }
}
